import React from 'react';

const VideoPlayer = ({ src }) => {
  return (
    <div className="mx-auto max-w-[640px]">
      <video
        controls
        autoPlay
        muted
        className="w-full rounded-lg shadow-lg"
        controlsList="nodownload"
      >
        <source src={src} type="video/mp4" />
        <track
          kind="captions"
          src="/captions/sample.vtt"
          srcLang="en"
          label="English"
          default
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
